import { IPayCustomPackageHandlerParams } from './payCustomPackage';
import { IPayPackageHandlerParams } from './payPackage';

export type TBillingUserType = 'legal' | 'natural';

export interface IPayPackageMicrofrontendAPI {
  buyPackage(parameters: IPayPackageHandlerParams): Promise<void>;
  buyCustomPackage(parameters: IPayCustomPackageHandlerParams): Promise<void>;
}

/** Типы пакетов для внутреннего использования на фронте */
export enum EInternalPackageType {
  /** Пакет (старый раздел, вкладка "Купить пакет") */
  LegacyPackage = 'legacy_package',
  /** Подписка (новый раздел, вкладка "Купить пакет") */
  Subscription = 'subscription',
  /** Персональный пакет (новый раздел, вкладка "Персональные предложения") */
  PersonalPackage = 'personal_package',
  /** Персональная подписка на слоты (новый раздел, вкладка "Персональные предложения") */
  PersonalSubscription = 'personal_subscription',
  /** Персональная подписка на публикации (новый раздел, вкладка "Персональные предложения") */
  PersonalSubscriptionPublication = 'personal_subscription_publication',
  /** Смарт-пакет (новый раздел, вкладка "Персональные предложения") */
  SmartPackage = 'smart_package',
  /** Конструктор (новый и старый разделы, вкладка "Собрать свой пакет") */
  CustomPackage = 'custom_package',
}

export enum EPackageType {
  // обычный пакет
  Common = 'commonOffer',
  // акция по промокоду
  Special = 'specialOffer',
  // персональное предложение
  Personal = 'personalOffer',
  /** Общее предложение - подписки на публикации **/
  CommonSubscription = 'commonSubscription',
  /** Смарт-пакет **/
  SmartPackage = 'smartPackage',
  /** Пакет "Всё включено" */
  AllIn = 'allIn',
  /** Подписка */
  Subscription = 'subscription',
}

export type TBalanceDetails = {
  balance: number;
  notEnough: number;
};

export enum ESubscriptionLevel {
  /** Бронзовый **/
  Bronze = 'bronze',
  /** Серебряный **/
  Silver = 'silver',
  /** Золотой **/
  Gold = 'gold',
  /** Платиновый **/
  Platinum = 'platinum',
}
